const home = {
  home: {
    hero: {
      kicker: 'خدمة استشارية سعودية فاخرة',
      badge: 'عقارات فاخرة',
      brandName: 'صفقات 24',
      tagline: 'منصتك العقارية الموثوقة',
      description: 'نقدم لك أفضل العقارات الفاخرة في المملكة العربية السعودية',
      title: 'اكتشف منازل مميزة في أهم مدن المملكة',
      subtitle:
        'صفقات 24 يجمع بين قوائم مختارة وخبرة ميدانية لضمان اختيار عقارك القادم بثقة.',
      search: {
        placeholder: 'ابحث حسب المدينة أو الحي أو رقم العقار',
        button: 'ابحث عن المنازل',
        // بحث الواجهة بنمط Rightmove: تبويبات شراء/إيجار/مبيعات + عنوان + حقل
        tablistLabel: 'نوع البحث',
        tabs: { buy: 'شراء', rent: 'إيجار', sold: 'مبيعات' },
        soon: 'قريباً',
        toBuy: 'ابحث عن عقارات للبيع',
        toRent: 'ابحث عن عقارات للإيجار',
        soldLabel: 'أسعار العقارات المباعة - قريباً',
        soldHint: 'بحث أسعار المبيعات قادم قريباً. اختر «شراء» أو «إيجار» للبحث الآن.',
        fieldPlaceholder: 'ابحث عن مدينة أو حي…',
        keywordPlaceholder: 'أضف كلمة مفتاحية (اختياري)…',
        removeLocation: 'إزالة الموقع',
        searchBtn: 'بحث',
        onMap: 'ابحث على الخريطة',
        filters: 'الفلاتر',
        propertyType: 'نوع العقار',
        allTypes: 'الكل',
        residential: 'سكني',
        commercial: 'تجاري',
        categoryLabel: 'نوع العقار: سكني أو تجاري',
        bathrooms: 'دورات المياه',
        priceLabel: 'السعر (ر.س)',
        min: 'من',
        max: 'إلى',
        areaUnit: 'م²',
        quickLabel: 'عمليات بحث شائعة',
        suggestions: [
          'فلل فاخرة في جدة',
          'شقق بإطلالة على البحر في جدة',
          'منازل أقل من 5 مليون ريال',
          'استثمارات واعدة في الخبر',
        ],
      },
      primaryCta: 'تصفح القوائم',
      secondaryCta: 'احجز استشارة',
    },
    location: {
      enableTitle: 'السماح بالوصول للموقع',
      enableDescription: 'للعثور على العقارات القريبة منك، نحتاج للوصول إلى موقعك',
      notNow: 'ليس الآن',
      allow: 'السماح',
      nearYou: 'بالقرب منك',
      propertiesIn: 'عقارات في {{city}}',
      chooseType: 'اختر ما تبحث عنه: إيجار أو شراء',
      all: 'الكل',
      forRent: 'للإيجار',
      forSale: 'للبيع',
      loading: 'جاري البحث عن العقارات...',
    },
    stats: {
      total: 'إجمالي القوائم',
      average: 'متوسط السعر',
      cities: 'مدن نخدمها',
    },
    featuresSection: {
      kicker: 'لماذا صفقات 24',
      title: 'كل ما تحتاجه في مكان واحد',
      description:
        'نجمع بين التحليل الذكي والخبرة العقارية لنقدم لك حلولاً مصممة حسب احتياجاتك الاستثمارية والمعيشية.',
    },
    features: {
      discovery: {
        title: 'بحث انتقائي',
        description:
          'نستخدم البيانات الموثوقة والمعرفة المحلية لتصفية العروض وحصرها في العقارات الأنسب.',
      },
      advisory: {
        title: 'بحث ذكي بالذكاء الاصطناعي',
        description:
          'نوظف تقنيات الذكاء الاصطناعي لتحليل آلاف العقارات وتقديم نتائج بحث دقيقة تتوافق مع متطلباتك.',
      },
      experience: {
        title: 'تحليل السوق بالذكاء الاصطناعي',
        description:
          'نقدم رؤى سوقية مبنية على الذكاء الاصطناعي لمساعدتك في فهم اتجاهات الأسعار واتخاذ قرارات استثمارية أفضل.',
      },
    },
    featured: {
      kicker: 'قوائم مميزة',
      title: 'منازل يفضلها عملاؤنا',
      subtitle:
        'مجموعة مختارة تجمع بين التصميم المعماري الراقي والمواقع الاستراتيجية والقيمة الاستثمارية طويلة الأجل.',
      badge: 'معروض حصرياً',
      priceLabel: 'سعر العرض',
      pricePerSqm: 'السعر لكل م²',
      bedLabel: 'غرف النوم',
      bathLabel: 'دورات المياه',
      areaLabel: 'المساحة الداخلية',
      viewDetails: 'عرض التفاصيل',
      exploreAll: 'تصفح جميع القوائم',
      empty: 'يتم إعداد قوائم مميزة جديدة، عد لاحقاً لاستكشاف المزيد.',
      properties: {
        'ksa-riyadh-01': {
          title: 'فيلا بإطلالة على حديقة الملك عبدالله في جدة',
          city: 'جدة',
        },
        'ksa-jeddah-02': {
          title: 'منزل على الواجهة البحرية محاط بالنخيل في جدة',
          city: 'جدة',
        },
        'ksa-dammam-03': {
          title: 'منزل عائلي معاصر في مرتفعات الدمام',
          city: 'الدمام',
        },
      },
    },
    quickSearch: {
      label: 'عمليات بحث مقترحة',
    },
    testimonials: {
      kicker: 'قصص عملائنا',
      title: 'موثوق بنا من قبل المشترين والمستثمرين',
      subtitle:
        'عملاؤنا يقدّرون السرية والمعرفة السوقية والنتائج التي نحققها في أهم أسواق المملكة.',
      items: [
        {
          name: 'سارة المطيري',
          role: 'مستثمرة عقارية',
          quote:
            'ساعدني صفقات 24 على اختيار فلل جاهزة للاستثمار في جدة مع تحليل دقيق للعائد المتوقع.',
        },
        {
          name: 'خالد الراشد',
          role: 'شريك تطوير',
          quote:
            'الفريق قدم رؤية تسعيرية دقيقة ودعم إطلاق مشروعنا في جدة، من التسويق حتى المبيعات المبكرة.',
        },
        {
          name: 'ليلى الحسن',
          role: 'مستأجر مؤسسي',
          quote:
            'أنجزوا عملية الانتقال لمكاتبنا في الخبر بسرعة، وتولوا التفاوض على شروط مرنة تناسب فريقنا.',
        },
      ],
    },
    // ── الصفحة الرئيسية بالهوية الجديدة 2026 (الاتجاه 3a). كل النصوص الجديدة
    //    تحت `home.v2.*` حتى لا تتعارض مع المفاتيح القديمة أعلاه. ────────────────
    v2: {
      strip: {
        servicesLabel: 'خدماتنا',
        categoriesLabel: 'تصفّح حسب الفئة',
        sell: 'بيع',
        buy: 'شراء',
        rent: 'للإيجار',
        invest: 'استثمار',
        residential: 'سكني',
        commercial: 'تجاري',
        land: 'أراضي',
        investment: 'استثمار',
      },
      hero: {
        boardTitle: 'ابحث عن عقارك المثالي',
        // The animated headline: the sentence is fixed, only `cities` cycles.
        dealLead: 'اقتنص أحلى صفقة عقارية في',
        cities: ['المدينة المنورة', 'الرياض', 'جدة', 'مكة المكرمة', 'الدمام', 'الخبر', 'أبها'],
        boardSubtitle: 'شقق - فلل - أراضي - تجارية',
        tagline: 'عقارك .. فرصتك الأفضل',
        promise: 'منصة عقارية موثوقة تجمع بين الفرص والراحة',
        badge: 'كل الإعلانات مرخّصة وموثّقة لدى الهيئة العامة للعقار',
        liveListings: 'إعلان مباشر',
        titleLead: 'اقتنص أحلى صفقة عقارية',
        titleAccent: 'حياتك.',
        subtitle:
          'منصّة عقارية موثوقة للبيع والإيجار والاستثمار في مختلف مناطق المملكة، بإعلانات مرخّصة.',
        searchOnMap: 'ابحث على الخريطة',
        popular: 'الأكثر بحثاً',
        chips: {
          villasRiyadh: 'فلل في الرياض',
          aptsJeddah: 'شقق في جدة',
          offplanKhobar: 'على الخارطة في الخبر',
          newProjects: 'مشاريع جديدة',
        },
        trust: {
          rega: 'مرخّص من الهيئة العامة للعقار',
          regaAuthority: 'REGA',
          fal: 'وسطاء موثّقون عبر «فال» فقط',
          cities: 'أكثر من 20 مدينة في المملكة',
        },
      },
      browseType: {
        title: 'تصفّح حسب نوع العقار',
        subtitle: 'انتقل مباشرةً إلى الفئة التي تبحث عنها.',
        listings: '{{n}} إعلان',
        plots: '{{n}} قطعة',
        types: {
          apartment: 'شقق',
          villa: 'فلل',
          land: 'أراضٍ',
          office: 'مكاتب',
          building: 'عمارات',
          rest_house: 'استراحات',
        },
      },
      featured: {
        eyebrow: 'مختارات هذا الأسبوع',
        title: 'عقارات مميزة',
        browseAll: 'تصفّح جميع العقارات',
        forSale: 'للبيع',
        forRent: 'للإيجار',
        isNew: 'جديد',
        verified: 'موثّق',
        // بطاقة العقار المختصرة: نصوص قارئ الشاشة بجانب الأرقام، وصيغ الجمع العربية كاملة.
        beds_one: 'غرفة نوم واحدة',
        beds_two: 'غرفتا نوم',
        beds_few: '{{n}} غرف نوم',
        beds_many: '{{n}} غرفة نوم',
        beds_other: '{{n}} غرفة نوم',
        baths_one: 'دورة مياه واحدة',
        baths_two: 'دورتا مياه',
        baths_few: '{{n}} دورات مياه',
        baths_many: '{{n}} دورة مياه',
        baths_other: '{{n}} دورة مياه',
        area: 'المساحة',
        // مدة الإيجار بعد السعر («/سنة»)، تظهر فقط إذا حدّدها الإعلان.
        period: { monthly: 'شهر', yearly: 'سنة', daily: 'يوم' },
      },
      cities: {
        title: 'تصفّح العقارات حسب المدينة',
        subtitle: 'من العاصمة إلى الساحل.',
        listings: '{{n}} إعلان',
        // عدد الإعلانات على بطاقة المدينة، بصيغ الجمع العربية.
        count_zero: 'لا توجد إعلانات بعد',
        count_one: 'إعلان واحد',
        count_two: 'إعلانان',
        count_few: '{{n}} إعلانات',
        count_many: '{{n}} إعلانًا',
        count_other: '{{n}} إعلان',
        names: { riyadh: 'الرياض', jeddah: 'جدة', dammam: 'الدمام', makkah: 'مكة المكرمة', madinah: 'المدينة المنورة' },
      },
      actions: {
        list: {
          title: 'أضف عقارك',
          body: 'للملّاك: النشر مجاني تحت رخصة صفقات 24، والعمولة 2.5% عند إتمام الصفقة فقط.',
          cta: 'ابدأ الإضافة',
        },
        request: {
          title: 'أرسل طلبك',
          body: 'أخبرنا بما تبحث عنه ودع الوسطاء المرخّصين يجلبون لك العقارات المناسبة.',
          cta: 'اعثر على منزل',
        },
        invest: {
          title: 'استثمر بالبيانات',
          body: 'نطاقات الأسعار والإيجارات والعوائد الإجمالية حسب الحي، من صفقات مسجّلة لدى وزارة العدل.',
          cta: 'استكشف المؤشرات',
        },
      },
      // الصف الأخير في الرئيسية: الحساب، المختصون، باقات المعلنين.
      nextSteps: {
        title: 'المزيد مع صفقات 24',
        account: {
          title: 'أنشئ حساباً مجانياً',
          body: 'احفظ العقارات التي تعجبك، وراسل المعلنين، وتابع ردودهم من مكان واحد.',
          cta: 'أنشئ حسابك',
        },
        favorites: {
          title: 'عقاراتك المحفوظة',
          body: 'ما حفظته من عقارات وردود المعلنين على استفساراتك، في مكان واحد.',
          cta: 'افتح المفضلة',
        },
        professionals: {
          title: 'ابحث عن مختص عقاري',
          body: 'وسطاء ومقيّمون ومديرو أملاك مرخّصون في مدينتك، تتواصل معهم مباشرة.',
          cta: 'تصفّح المختصين',
        },
        plans: {
          title: 'باقات المعلنين',
          body: 'للوسطاء والشركات والمطورين: انشر إعلاناتك، وميّزها، وتابع مشاهداتها.',
          cta: 'اطّلع على الباقات',
        },
      },
      why: {
        eyebrow: 'لماذا صفقات 24',
        title: 'المكان الموثوق للانتقال في السعودية.',
        cta: 'أنشئ حساباً مجانياً',
        items: {
          verified: { title: 'تراخيص واضحة', body: 'نعرض رقم ترخيص الإعلان ورخصة فال للمعلن متى توفّرت، لتتحقق منها بنفسك.' },
          support: { title: 'دعم فني', body: 'مختصون بلغتين يرافقونك من أول بحث حتى توقيع العقد.' },
          faster: { title: 'ابحث بطريقتك', body: 'صِف ما تريد بكلماتك، أو ارسم منطقتك على الخريطة لتظهر العقارات داخلها.' },
        },
        // Each label follows its number (rendered separately), so the noun must
        // agree with it: i18next picks the form from the count via the Arabic
        // plural rules (one 1 · two 2 · few 3-10 · many 11-99 · other 100+).
        stats: {
          listings: 'إعلان منشور',
          listings_zero: 'إعلان منشور',
          listings_one: 'إعلان منشور',
          listings_two: 'إعلانان منشوران',
          listings_few: 'إعلانات منشورة',
          listings_many: 'إعلاناً منشوراً',
          listings_other: 'إعلان منشور',
          brokers: 'وسيط مرخّص',
          brokers_zero: 'وسيط مرخّص',
          brokers_one: 'وسيط مرخّص',
          brokers_two: 'وسيطان مرخّصان',
          brokers_few: 'وسطاء مرخّصين',
          brokers_many: 'وسيطاً مرخّصاً',
          brokers_other: 'وسيط مرخّص',
          cities: 'مدينة مغطّاة',
          cities_zero: 'مدينة مغطّاة',
          cities_one: 'مدينة مغطّاة',
          cities_two: 'مدينتان مغطّاتان',
          cities_few: 'مدن مغطّاة',
          cities_many: 'مدينةً مغطّاةً',
          cities_other: 'مدينة مغطّاة',
        },
      },
      brokers: {
        eyebrow: 'شبكة موثّقة',
        title: 'وسطاء موثوقون في أنحاء المملكة',
        subtitle: 'استكشف الوسطاء والمكاتب المرخّصة من الهيئة حسب مناطق عملهم - ثم افتح الخريطة التفاعلية الكاملة.',
        viewMap: 'استكشف خريطة الوسطاء',
        viewAll: 'عرض كل الوسطاء',
        listings: '{{n}} إعلان',
        empty: 'يجري التحقق من ملفات الوسطاء - عد لاحقاً.',
      },
      projects: {
        eyebrow: 'على الخارطة وجديد',
        title: 'مشاريع جديدة مميزة',
        all: 'كل المطوّرين',
        offplan: 'على الخارطة',
        ready: 'جاهز',
        units: '{{n}} وحدة',
        empty: 'يتم إعداد المشاريع الجديدة؛ عد لاحقاً.',
      },
      listCta: {
        title: 'جاهز للإضافة؟ اعرض عقارك أمام المملكة كلها.',
        body: 'النشر مجاني، مرخّص من الهيئة، ويشاهده آلاف المشترين والمستأجرين الموثّقين يومياً.',
        cta: 'أضف عقارك',
      },
    },
  },
};

export default home;

